// File: produkRumahService.js

import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  Authorization: `Bearer ${getAuthToken()}`,
  'Content-Type': 'application/json'
});

const PRODUK_RUMAH_ENDPOINT = "/produk-rumah";


// ======================
// FETCH ALL
// ======================

export const fetchProdukRumahs = async (params = {}) => {
  try {

    const urlParams = new URLSearchParams({});

    // pagination
    if (params.disable_pagination) {
      urlParams.append(
        'disable_pagination',
        'true'
      );
    } else {
      urlParams.append(
        'page',
        params.page || 1
      );

      urlParams.append(
        'per_page',
        params.per_page || 10
      );
    }

    // search
    if (params.search) {
      urlParams.append(
        'search',
        params.search
      );
    }

    // filter id_rumah
    if (params.id_rumah) {
      urlParams.append(
        'id_rumah',
        params.id_rumah
      );
    }

    // filter lokasi
    if (params.id_lokasi) {
      urlParams.append(
        'id_lokasi',
        params.id_lokasi
      );
    }

     if (params.id_wilayah) {
      urlParams.append(
        'id_wilayah',
        params.id_wilayah
      );
    }

    // filter blok
    if (params.id_blok) {
      urlParams.append(
        'id_blok',
        params.id_blok
      );
    }

    const response =
      await axios.get(
        `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}?${urlParams.toString()}`,
        {
          headers: getAuthHeaders()
        }
      );

    return response.data;

  } catch (error) {

    console.error(
      "Error fetching Produk Rumah:",
      error
    );

    throw error;
  }
};

export const fetchUnitDijual = async (params = {}) => {
  try {

    const urlParams = new URLSearchParams({});

    // pagination
    if (params.disable_pagination) {
      urlParams.append(
        'disable_pagination',
        'true'
      );
    } else {
      urlParams.append(
        'page',
        params.page || 1
      );

      urlParams.append(
        'per_page',
        params.per_page || 10
      );
    }

    // search
    if (params.search) {
      urlParams.append(
        'search',
        params.search
      );
    }

    // filter id_rumah
    if (params.id_rumah) {
      urlParams.append(
        'id_rumah',
        params.id_rumah
      );
    }

    // filter lokasi
    if (params.id_lokasi) {
      urlParams.append(
        'id_lokasi',
        params.id_lokasi
      );
    }

      if (params.id_wilayah) {
      urlParams.append(
        'id_wilayah',
        params.id_wilayah
      );
    }

    // filter blok
    if (params.id_blok) {
      urlParams.append(
        'id_blok',
        params.id_blok
      );
    }

    const response =
      await axios.get(
        `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}/unit-rumah?${urlParams.toString()}`,
        {
          headers: getAuthHeaders()
        }
      );

    return response.data;

  } catch (error) {

    console.error(
      "Error fetching Produk Rumah:",
      error
    );

    throw error;
  }
};

export const fetchAllUnitRumah = async (params = {}) => {
  try {

    const urlParams = new URLSearchParams({});

    // pagination
    if (params.disable_pagination) {
      urlParams.append(
        'disable_pagination',
        'true'
      );
    } else {
      urlParams.append(
        'page',
        params.page || 1
      );

      urlParams.append(
        'per_page',
        params.per_page || 10
      );
    }

    // search
    if (params.search) {
      urlParams.append(
        'search',
        params.search
      );
    }

    // filter id_rumah
    if (params.id_rumah) {
      urlParams.append(
        'id_rumah',
        params.id_rumah
      );
    }

    // filter lokasi
    if (params.id_lokasi) {
      urlParams.append(
        'id_lokasi',
        params.id_lokasi
      );
    }

      if (params.id_wilayah) {
      urlParams.append(
        'id_wilayah',
        params.id_wilayah
      );
    }

    // filter blok
    if (params.id_blok) {
      urlParams.append(
        'id_blok',
        params.id_blok
      );
    }

    const response =
      await axios.get(
        `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}/all-rumah?${urlParams.toString()}`,
        {
          headers: getAuthHeaders()
        }
      );

    return response.data;

  } catch (error) {

    console.error(
      "Error fetching Produk Rumah:",
      error
    );

    throw error;
  }
};


// ======================
// GET BY ID
// ======================

export const fetchProdukRumahById = async (
  id
) => {

  try {

    const response =
      await axios.get(
        `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}/${id}`,
        {
          headers: getAuthHeaders()
        }
      );

    return response.data;

  } catch (error) {

    console.error(
      "Error fetching Produk Rumah Detail:",
      error
    );

    throw error;
  }

};


// ======================
// CREATE
// ======================

export const createProdukRumah = async (
  formData
) => {

  try {

    const response =
      await axios.post(
        `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}`,
        formData,
        {
          headers: getAuthHeaders()
        }
      );

    return response.data;

  } catch (error) {

    console.error(
      "Error create Produk Rumah:",
      error
    );

    throw error;
  }

};


// ======================
// UPDATE
// ======================

export const updateProdukRumah = async (
  id,
  formData
) => {

  try {

    const response =
      await axios.put(
        `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}/${id}`,
        formData,
        {
          headers: getAuthHeaders()
        }
      );

    return response.data;

  } catch (error) {

    console.error(
      "Error update Produk Rumah:",
      error
    );

    throw error;
  }

};


// ======================
// DELETE
// ======================

export const deleteProdukRumah = async (
  id
) => {

  try {

    const response =
      await axios.delete(
        `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}/${id}`,
        {
          headers: getAuthHeaders()
        }
      );

    return response.data;

  } catch (error) {

    console.error(
      "Error delete Produk Rumah:",
      error
    );

    throw error;
  }

};

// ======================
// PENGAJUAN PRODUK RUMAH (KEPALA CABANG)
// ======================

export const fetchPendingProdukRumah = async (params = {}) => {
  try {
    const urlParams = new URLSearchParams();

    urlParams.append("page", params.page || 1);
    urlParams.append("per_page", params.per_page || 10);
    if (params.disable_pagination) urlParams.append("disable_pagination", "true");
    if (params.status) urlParams.append("status", params.status);
    if (params.search) urlParams.append("search", params.search);
    if (params.id_lokasi) urlParams.append("id_lokasi", params.id_lokasi);
    if (params.id_blok) urlParams.append("id_blok", params.id_blok);

    const response = await axios.get(
      `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}/pending?${urlParams.toString()}`,
      { headers: getAuthHeaders() }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching pengajuan Produk Rumah:", error);
    throw error;
  }
};

export const approvePendingProdukRumah = async (id, catatan = "") => {
  try {
    const response = await axios.put(
      `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}/pending/${id}/approve`,
      { catatan },
      { headers: getAuthHeaders() }
    );

    return response.data;
  } catch (error) {
    console.error("Error approve pengajuan Produk Rumah:", error);
    throw error;
  }
};

export const rejectPendingProdukRumah = async (id, catatan = "") => {
  try {
    const response = await axios.put(
      `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}/pending/${id}/reject`,
      { catatan },
      { headers: getAuthHeaders() }
    );

    return response.data;
  } catch (error) {
    console.error("Error reject pengajuan Produk Rumah:", error);
    throw error;
  }
};

export const bulkApprovePendingProdukRumah = async (ids, catatan = "") => {
  try {
    const response = await axios.put(
      `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}/pending/bulk-approve`,
      { ids, catatan },
      { headers: getAuthHeaders() }
    );

    return response.data;
  } catch (error) {
    console.error("Error bulk approve pengajuan Produk Rumah:", error);
    throw error;
  }
};

export const bulkRejectPendingProdukRumah = async (ids, catatan = "") => {
  try {
    const response = await axios.put(
      `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}/pending/bulk-reject`,
      { ids, catatan },
      { headers: getAuthHeaders() }
    );

    return response.data;
  } catch (error) {
    console.error("Error bulk reject pengajuan Produk Rumah:", error);
    throw error;
  }
};

export const fetchBlokProdukRumahs = async (params = {}) => {
  try {

    const urlParams = new URLSearchParams({});

    // pagination
    if (params.disable_pagination) {
      urlParams.append(
        'disable_pagination',
        'true'
      );
    } else {
      urlParams.append(
        'page',
        params.page || 1
      );

      urlParams.append(
        'per_page',
        params.per_page || 10
      );
    }

    // search
    if (params.search) {
      urlParams.append(
        'search',
        params.search
      );
    }

    // filter id_rumah
    if (params.id_rumah) {
      urlParams.append(
        'id_rumah',
        params.id_rumah
      );
    }

    // filter lokasi
    if (params.id_lokasi) {
      urlParams.append(
        'id_lokasi',
        params.id_lokasi
      );
    }

    // filter blok
    if (params.id_blok) {
      urlParams.append(
        'id_blok',
        params.id_blok
      );
    }

    const response =
      await axios.get(
        `${BASE_URL_BE}${PRODUK_RUMAH_ENDPOINT}/blok?${urlParams.toString()}`,
        {
          headers: getAuthHeaders()
        }
      );

    return response.data;

  } catch (error) {

    console.error(
      "Error fetching Produk Rumah:",
      error
    );

    throw error;
  }
};
